module.exports = __webpack_public_path__ + "static/iphone-app-screens-d39c5213b8ac56c11873d1559bddf95c.webp";